<script>
  import { Router, Route } from "svelte-navigator";
  import Home from "./routes/Home.svelte";
  import Record from "./routes/Record.svelte";
  import Grid from "./routes/Grid.svelte";
  import Time from "./routes/Time.svelte";
  import Privacy from "./routes/Privacy.svelte";
  import Terms from "./routes/Terms.svelte";
  import Landing from "./routes/Landing.svelte";

  const website = location.host.includes("icapella") || location.search.includes("site");
</script>

<Router>
  <Route path="record/:grid/:time" component={Record} />
  <Route path="time/:grid" component={Time} />
  <Route path="grid" component={Grid} />
  <Route path="privacy" component={Privacy} />
  <Route path="terms" component={Terms} />
  <Route path="/" component={website ? Landing : Home} />
</Router>
